import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useCreateSingleSeriesMutation = createMutationHook(
  MembershipsCreatorV2ApiClient.createSingleSeries,
  {
    mutationKey: ['createSingleSeries'],
  },
)
